import { Helmet } from 'react-helmet';
import TinhluongDetail
  from 'src/components/tinhluong-detail/TinhluongDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import TinhluongListToolbar from '../components/tinhluong-detail/TinhluongListToolbar';

const TinhluongList = () => (
  <>
    <Helmet>
      <title>Tính lương</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <TinhluongListToolbar />
        <Box sx={{ pt: 3 }}>
          <TinhluongDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default TinhluongList;
